module.exports = __webpack_public_path__ + "img/gift.e49476c1.svg";